interface RewardRiskMeterProps {
  rewardRisk: number | null;
}

export function RewardRiskMeter({ rewardRisk }: RewardRiskMeterProps) {
  const value = rewardRisk ?? 0;
  const pct = Math.min(100, (value / 3) * 100);
  const label = rewardRisk === null ? 'No target' : `${rewardRisk.toFixed(2)}R`;

  return (
    <section className="rounded border border-border bg-surface p-4">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-lg font-semibold">Reward/risk</h2>
        <span className="font-mono text-sm tabular-nums">{label}</span>
      </div>
      <div
        className="mt-3 h-3 rounded bg-bg-muted"
        role="meter"
        aria-label="Reward risk gauge"
        aria-valuemin={0}
        aria-valuemax={3}
        aria-valuenow={value}
        aria-valuetext={label}
      >
        <div className="h-3 rounded bg-primary" style={{ width: `${pct}%` }} />
        {rewardRisk !== null ? (
          <span
            className="relative block h-5 w-0.5 -translate-y-4 bg-white"
            style={{ left: `${pct}%` }}
            aria-hidden="true"
          />
        ) : null}
      </div>
      <div className="mt-2 flex justify-between text-xs text-text-muted">
        <span>0R</span>
        <span>2R</span>
        <span>3R+</span>
      </div>
    </section>
  );
}
